import React, {useState, useRef, useEffect} from 'react';
import dynamic from 'next/dynamic';

import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/counter.css';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';
import Counter from 'yet-another-react-lightbox/plugins/counter';
import {StyledLightbox} from './styles';
import ProductCarousel from '../product-carousel/product-carousel';
import Search from '../icons-af/search';
import elementFactory from '../../utils/element';
import _ from '../../utils/_';
import constantsFactory from '../../utils/constants';
import useMounted from '../../hooks/use-mounted/use-mounted';
import '../carousel-scroll/carousel-scroll.scss';
import './product-carousel-full-screen.scss';

const {KEYS, BREAKPOINTS} = constantsFactory();

const ProductCarouselVerticalWithNoSSR = dynamic(
  () => import('../product-carousel-vertical/product-carousel-vertical'),
  {
    ssr: false,
    loading: () => (
      <div className="carousel-scroll carousel-scroll-vertical product-carousel-vertical" />
    ),
  },
);

const ProductCarouselFullScreen = ({items, alt}) => {
  const carouselIntance = useRef({set: (_) => {}});
  const [slideIndex, setSlideIndex] = useState(0);
  const [active, setActive] = useState(false);
  const [showVertical, setShowVertical] = useState(true);
  const hasMounted = useMounted();

  useEffect(() => {
    const handleChange = _.pipe(_.prop('matches'), setShowVertical);
    // todo: extract the breackpoints as constants
    const largeAndUp = window.matchMedia('(min-width: 992px)');
    largeAndUp.addListener(handleChange);
    return () => {
      largeAndUp.removeListener(handleChange);
    };
  }, []);

  useEffect(() => {
    // Making sure page doesn't scroll while user is zooming into gallery images
    active ? (document.body.style.overflow = 'hidden') : (document.body.style.overflow = 'visible');
  }, [active]);

  const handleSlideChange = (_, to) => {
    setSlideIndex(to);
  };

  const toggle = () => {
    setActive(!active);
  };

  useEffect(() => {
    const $ = elementFactory(document, window);
    const handler = (e) => {
      if (e.which === KEYS.ESC) {
        setActive(false);
        e.preventDefault();
      }
    };
    $.on('keydown', handler, document, {capture: true});
    return () => {
      $.off('keydown', handler, document, {capture: true});
    };
  }, []);

  return (
    <div className="product-carousel-with-vertical">
      {showVertical && (
        <ProductCarouselVerticalWithNoSSR
          items={items}
          alt={alt}
          active={slideIndex}
          onChange={(n) => carouselIntance.current.set(n)}
        />
      )}
      <div className="product-carousel-full-screen">
        {hasMounted && (
          <StyledLightbox
            open={active}
            close={() => setActive(!active)}
            index={slideIndex}
            slides={items.map((item) => {
              return {
                src: item.retina_url,
              };
            })}
            toolbar={{buttons: ['close']}}
            carousel={{padding: window.matchMedia(BREAKPOINTS.MEDIUM_AND_DOWN).matches ? 0 : 44}}
            controller={{closeOnBackdropClick: true}}
            plugins={[Zoom, Counter]}
            zoom={{scrollToZoom: true, maxZoomPixelRatio: 2, zoomInMultiplier: 1.5}}
          />
        )}
        <div role="button" className="product-carousel-full-screen-toggle" onClick={toggle}>
          <Search height="100%" width="16px" />
        </div>
        {/* todo: initWidth should be worked out
            on the most used [mobile] device */}
        <ProductCarousel
          items={items}
          alt={alt}
          maxHeight={600}
          initWidth={750}
          showIndicators={false}
          onChange={handleSlideChange}
          instanceRef={carouselIntance}
          addSwipeEvent={true}
          clickEvent={toggle}
        />
      </div>
      <ol className="carousel-indicators">
        {items.map((_, i) => (
          <li
            key={i}
            data-slide-to={i}
            className={i === slideIndex ? 'active' : ''}
            onClick={() => carouselIntance.current.set(i)}
          ></li>
        ))}
      </ol>
    </div>
  );
};

export default ProductCarouselFullScreen;
